import { Component, OnInit } from '@angular/core';
import { ApplicationsService } from '../../applications/applications.service';
import { NbaComponent } from '../../authentication/nba/nba.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-loan-bursary-decision',
  templateUrl: './loan-bursary-decision.component.html',
  styleUrls: ['./loan-bursary-decision.component.scss']
})
export class LoanBursaryDecisionComponent implements OnInit {

  constructor(public applicationService: ApplicationsService, public modalService: NgbModal, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    // this.applicationService.application.fundingBucket = 'BURSARY';
  }

  close() {
    this.modalService.dismissAll();
  }

  openLoanConfirmationDialog() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: "Are you sure you want to select 'LOAN' for this application?",
        confirmText: 'Yes, Proceed',
        cancelText: 'No, Cancel'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.applicationService.application.fundingBucket = 'LOAN';
        this.applicationService.application.loanConfirmation = true;
        this.openUnderGradConfirmationDialog();

      } else {
        this.applicationService.application.fundingBucket = null;
        return
      }
    });
  }

  openUnderGradConfirmationDialog() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: "Are you applying as a 'Postgraduate' or an 'Undergraduate' student?",
        confirmText: 'Undergraduate',
        cancelText: 'Postgraduate'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.applicationService.application.loanQualification = "Undergraduate";

      } else {
        this.applicationService.application.loanQualification = "Postgraduate";
        return
      }
    });
  }


  nbaDocuments() {
    const modalRef = this.modalService.open(NbaComponent, { fullscreen: true, modalDialogClass: 'animate-bottom' });
    modalRef.componentInstance.name = 'World';
    modalRef.closed.subscribe(() => {
    });

  }
}
